import React from "react"

/** When true, `KlassappTable` uses native overflow instead of Perfect Scrollbar (needed inside `BasePopup` with RTL modal wrap). */
export const BasePopupTableScrollContext = React.createContext(false)

export function BasePopupTableScrollProvider(props: {children: React.ReactNode}) {
    return <BasePopupTableScrollContext.Provider value={true}>{props.children}</BasePopupTableScrollContext.Provider>
}
